import { Immutable } from "immer";
import React, { useEffect } from "react";
import { t } from "ttag";

import type { ProductReviewBlock as Value } from "@reactivated";

import { loadPowerReviews } from "../../utils/powerreviews";

type IProps = Immutable<{
    value: Value;
}>;

/**
 * Faithful JSX transcription of the legacy sealy
 * ``components/product_reviews/reviews.html`` (#33285).
 *
 * The legacy template loaded the PowerReviews ui.js synchronously and called
 * ``POWERREVIEWS.display.render`` inline at parse time; loading it
 * post-hydration in an effect is the React equivalent and survives client
 * re-renders.
 */
export const ProductReviewBlock = (props: IProps): React.JSX.Element => {
    const pageId = props.value.page_id ?? "";
    const styleSheetUrl = props.value.style_sheet_url;
    useEffect(() => {
        let cancelled = false;
        loadPowerReviews()
            .then((pr) => {
                if (cancelled) {
                    return;
                }
                pr.display.render({
                    api_key: "e1f8faa4-1490-4696-a021-a47cf58e9c25",
                    locale: "en_US",
                    merchant_group_id: "78466",
                    merchant_id: "183461",
                    page_id: pageId,
                    page_id_variant: "",
                    review_wrapper_url: `/reviews/write-a-review?page_id=${pageId}`,
                    style_sheet: styleSheetUrl,
                    components: {
                        ReviewSnippet: "pr-reviewsnippet",
                        ReviewDisplay: "pr-reviewdisplay",
                    },
                });
            })
            .catch(() => {
                // PowerReviews unavailable; the containers stay empty, same
                // as the legacy script-error case.
            });
        return () => {
            cancelled = true;
        };
    }, []);
    return (
        <section className="reviews ptb">
            <div className="container">
                <div className="lead-in container">
                    <h3 className="lead-in__headline">
                        {t`What People Are Saying`}
                    </h3>
                </div>
                <div id="pr-reviewsnippet"></div>
                <div id="pr-reviewdisplay"></div>
            </div>
        </section>
    );
};
